export const GRID_GROUP_TYPE = Symbol('group');
export const GRID_GROUP_CHECK = Symbol(`${GRID_GROUP_TYPE.toString()}_check`);
export const GRID_GROUP_LEVEL_KEY = Symbol(`${GRID_GROUP_TYPE.toString()}_levelKey`);
export const GRID_GROUP_COLLAPSED_ROWS = Symbol(`${GRID_GROUP_TYPE.toString()}_collapsedRows`);
